var exports = {
  "nV": "xa15a2ab7--e16ae2--gallery",
  "q9": "xa15a2ab7--e16ae2--price",
  "hl": "xa15a2ab7--e16ae2--address",
  "DD": "xa15a2ab7--e16ae2--title",
  "kp": "xa15a2ab7--e16ae2--kp",
  "qT": "xa15a2ab7--e16ae2--features",
  "U1": "xa15a2ab7--e16ae2--redirect-btn",
};

module.exports = exports;
